import { NavLink } from 'react-router-dom'
import { 
  Home, 
  DollarSign, 
  CheckSquare, 
  Calendar, 
  ShoppingCart, 
  Users, 
  Package,
  Heart
} from 'lucide-react'
import { motion } from 'framer-motion'

const MobileNav = () => {
  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: Home },
    { name: 'Finanças', href: '/finance', icon: DollarSign },
    { name: 'Tarefas', href: '/tasks', icon: CheckSquare },
    { name: 'Calendário', href: '/calendar', icon: Calendar },
    { name: 'Saúde', href: '/health', icon: Heart },
    { name: 'Compras', href: '/shopping', icon: ShoppingCart },
    { name: 'Mural', href: '/family-board', icon: Users },
    { name: 'Itens', href: '/items-control', icon: Package },
  ]

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-neutral-200 px-2 py-1 z-50">
      <div className="flex justify-around">
        {navigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            className={({ isActive }) =>
              `flex flex-col items-center py-2 px-1 min-w-0 flex-1 transition-colors duration-200 ${
                isActive
                  ? 'text-primary-600'
                  : 'text-neutral-500 hover:text-neutral-700'
              }`
            }
          >
            {({ isActive }) => (
              <motion.div
                className="flex flex-col items-center"
                whileTap={{ scale: 0.95 }}
                transition={{ duration: 0.1 }}
              >
                <item.icon
                  className={`h-5 w-5 mb-1 ${
                    isActive ? 'text-primary-600' : 'text-neutral-500'
                  }`}
                />
                <span className="text-xs font-medium truncate">
                  {item.name}
                </span>
                {isActive && (
                  <motion.div
                    className="w-1 h-1 bg-primary-600 rounded-full mt-1"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.2 }}
                  />
                )}
              </motion.div>
            )}
          </NavLink>
        ))}
      </div>
    </div>
  )
}

export default MobileNav

